import { toast, Toaster, ToastBar } from "react-hot-toast";

import useSystemStore from "@store/useSystemStore";
import { APP_COLORS } from "@styles/colors";

function getToastBackground(type: string, isDark: boolean) {
  if (type === "error") {
    return isDark
      ? APP_COLORS.yellow[900]
      : APP_COLORS.yellow[100];
  }
  return isDark ? APP_COLORS.emerald[900] : APP_COLORS.emerald[100];
}

function getToastBorder(type: string, isDark: boolean) {
  if (type === "error") {
    return isDark
      ? `1px solid ${APP_COLORS.yellow[600]}`
      : "none";
  }
  return "none";
}

function getToastTextColor(type: string, isDark: boolean) {
  if (type === "error") {
    return isDark
      ? APP_COLORS.yellow[300]
      : APP_COLORS.yellow[700];
  }
  return isDark
    ? APP_COLORS.emerald[400]
    : APP_COLORS.emerald[700];
}

export function AppToaster() {
  const { isDarkMode } = useSystemStore();
  return (
    <Toaster
      position="bottom-center"
      gutter={12}
      containerStyle={{
        bottom: 20,
        zIndex: 100,
      }}
      toastOptions={{
        style: {
          borderRadius: "8px",
          boxShadow: "0 2px 12px 0 rgba(0,0,0,0.08)",
          minWidth: "260px",
          maxWidth: "340px",
          height: "auto",
          minHeight: "32px",
          width: "auto",
          textAlign: "center",
          fontSize: "13px",
          padding: "8px 0",
          margin: "0 auto",
        },
        success: {
          iconTheme: {
            primary: APP_COLORS.teal[900],
            secondary: APP_COLORS.emerald[200],
          },
        },
        error: {
          duration: 10000,
          style: {
            padding: "12px 16px",
            textAlign: "left",
          },
        },
      }}
    >
      {(t) => (
        <ToastBar
          toast={t}
          style={{
            background: getToastBackground(t.type, isDarkMode),
            color: getToastTextColor(t.type, isDarkMode),
            border: getToastBorder(t.type, isDarkMode),
          }}
        >
          {({ message }) => (
            <>
              <span className="w-full [&>div]:block">{message}</span>
              {/* Only ToastService.showError / showUserError produce this type. */}
              {t.type === "error" && (
                <button
                  aria-label="Dismiss notification"
                  className="mr-2 flex-shrink-0 rounded p-0.5 text-current opacity-70 hover:opacity-100"
                  onClick={() => toast.dismiss(t.id)}
                >
                  ✕
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}
